module.exports = __webpack_public_path__ + "static/fipcbluefloral3-0d6707a9f488f1d96abcdfe9ea4ecf04.jpeg";